import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import i18next from "i18next";
import { Image } from "hesus-ui-kit";
import addIcon from "@icons/ic-add-white.svg";
import AddEditMeetingReport from "../AddEditMeetingReport/AddEditMeetingReport";
import PrepareDataTable from "./PrepareDataTable";
import {
  MeetingReportsListContainer,
  HeaderWrapper,
  Title,
  AddMeetingReports,
} from "./MeetingReportsList.styled";
import UserInfo from "@utils/UserInfo";

import "./MeetingReportsList.scss";
import { TABLE_MEETING_REPORTS_LIST } from "@utils/constants";
/**
 * MeetingReportsList List,
 * Path - /analyticalNotes
 * @see See [AnalyticalNotes Requirements](https://hesusstore.atlassian.net/wiki/spaces/HS/pages/2881060894/Analytical+notes+form)
 * @component
 */
const MeetingReportsList = (props) => {
  const { t, objectType, objectId, columnList, isHeader, type, countryId } =
    props;

  const [isRefreshList, setIsRefreshList] = useState(false);

  const [isAddMeetingReportPopupVisible, setAddMeetingReportPopupVisible] =
    useState(false);
  const [defaultCountryId, setDefaultCountryId] = useState("");
  const [selectedCountryForFilter, setSelectedCountryForFilter] = useState([]);

  const userCountryId = UserInfo.countryId();
  const countryList = UserInfo.countryListForFilter(t);

  const createEditMeetingReport = () => {
    setAddMeetingReportPopupVisible(true);
  };

  const closeMeetingReportPopupVisible = () => {
    setAddMeetingReportPopupVisible(false);
  };

  const updateRefeshStatus = () => {
    setIsRefreshList(true);
  };

  useEffect(() => {
    if (isRefreshList) {
      setIsRefreshList(false);
    }
  }, [isRefreshList]);

  useEffect(() => {
    const effectiveCountryId = countryId ?? userCountryId;
    const selectedCountry = countryList.find(
      (data) => data.value === effectiveCountryId
    );
    setSelectedCountryForFilter(selectedCountry);
    setDefaultCountryId(effectiveCountryId);
  }, []);

  return (
    <MeetingReportsListContainer
      className="meeting-reports-list"
      marginTop={isHeader === "main" ? "30px" : "0px"}
      boxShadow={
        isHeader !== "main" ? "none" : "2px 4px 4px 0 rgb(0 0 0 / 25%)"
      }
    >
      {isHeader === "sub-menu-old" && (
        <HeaderWrapper>
          <Title>{t("MEETING_REPORTS")}</Title>
          <AddMeetingReports>
            <Image src={addIcon} onClick={createEditMeetingReport} alt="add" />
          </AddMeetingReports>
        </HeaderWrapper>
      )}
      {isHeader === "main" && (
        <h2 className="kick-off-list__title">{t("MEETING_REPORTS")}</h2>
      )}
      {defaultCountryId && (
        <PrepareDataTable
          type={type}
          isRefreshList={isRefreshList}
          updateRefeshStatus={updateRefeshStatus}
          objectType={objectType}
          objectId={objectId}
          columnList={columnList}
          createNewAction={createEditMeetingReport}
          countryId={defaultCountryId}
          mainCountryInfo={selectedCountryForFilter}
        />
      )}
      {isAddMeetingReportPopupVisible && (
        <AddEditMeetingReport
          title={t("MEETING_REPORT")}
          onClose={closeMeetingReportPopupVisible}
          updateRefeshStatus={updateRefeshStatus}
          objectType={objectType}
          objectId={objectId}
          countryId={defaultCountryId}
        />
      )}
    </MeetingReportsListContainer>
  );
};

MeetingReportsList.propTypes = {
  t: PropTypes.func.isRequired,
  isHeader: PropTypes.string,
  type: PropTypes.string,
  countryId: PropTypes.number,
};

MeetingReportsList.defaultProps = {
  isHeader: "main",
  type: TABLE_MEETING_REPORTS_LIST,
  countryId: null,
};

export default withTranslation()(MeetingReportsList);
